import { Flex } from "@acko-tech/building-blocks.ui.common";
import styled from "styled-components";

export const DropdownWrapper = styled(Flex)`
  width: 100%;
  // @media(max-width: 768px) {
  //   width: 95%;
  // }
`;
